import React from 'react'
import { PlusCircle, Shapes } from '@phosphor-icons/react'
import { Button } from '@shopflo/ui'
import { useLocale } from 'src/lib/hooks/useLocal'
import { DynamicSegmentFilterType, SegmentTemplateType } from 'src/lib/types/segment'
import { useDynamicSegment } from 'src/lib/contexts/DynamicSegmentContext'
import FilterModal from './FilterModal'
import SegmentConditionFilterLayout from './SegmentConditionFilterLayout'
import TemplateDropdown from './TemplateDropdown'

interface SegmentConditionBuilderProps {
  /** Host override for template application; falls back to the context's applyTemplateById. */
  onTemplateSelect?: (template: SegmentTemplateType) => void
}

const SegmentConditionBuilder: React.FC<SegmentConditionBuilderProps> = ({ onTemplateSelect }) => {
  const { t } = useLocale()

  const { segmentFormState, actions, isEditMode } = useDynamicSegment()
  const { addNewFilter, applyTemplateById } = actions

  return (
    <div className='flex flex-col gap-2'>
      {Boolean(segmentFormState.filters.length) ? (
        <SegmentConditionFilterLayout />
      ) : (
        <div className='flex flex-col gap-2 px-8'>
          {/* Use Template Button */}
          {!isEditMode && (
            <TemplateDropdown
              trigger={
                <Button
                  variant='dashed'
                  size='sm'
                  leftIcon={Shapes}
                  className='bg-transparent h-7 w-fit text-text-sm-medium'
                >
                  {t('segment_creation.use_template')}
                </Button>
              }
              onTemplateSelect={(template: SegmentTemplateType) => {
                if (onTemplateSelect) {
                  onTemplateSelect(template)
                  return
                }
                void applyTemplateById(template.id)
              }}
            />
          )}
          {/* Add Condition Button */}
          <FilterModal trigger={
            <Button
              variant='dashed'
              size='sm'
              leftIcon={PlusCircle}
              className='bg-transparent h-7 w-fit text-text-sm-medium'
            >
              {t('segment_creation.add_condition')}
            </Button>
          }
            onSelectField={(filter: DynamicSegmentFilterType) => {
              addNewFilter(filter)
            }} />
        </div>
      )}
    </div>
  )
}

export default SegmentConditionBuilder
